type Props = {
	useLocalStorage?: boolean;
};

/**
 * Checks authentication and redirects to login page if not authenticated.
 *
 * @param props - Configuration options for authentication check
 * @param props.useLocalStorage - Whether to check authentication using local storage instead of the default method.
 * 																This is to optimistically check auth state without an API call.
 * 																False by default.
 * @returns A promise that resolves to `true` if authenticated, or `undefined` if redirected to login
 */
export async function checkAuthAndMaybeRedirect({ useLocalStorage = false }: Props = {}): Promise<
	true | undefined
> {
	const session = window.valioApp?.session;
	const loginUrl = '/oma-valio';
	let isAuthenticated: boolean;

	if (useLocalStorage) {
		isAuthenticated = await session.isLoggedInWithLocalStorage();
	} else {
		isAuthenticated = await session.isLoggedIn();
	}

	if (!isAuthenticated) {
		window.location.href = loginUrl; // Redirect to login if user is not authenticated
		return;
	}

	// User is authenticated, proceed as normal
	return true;
}
